import borders from "../base/borders";
import colors from "../base/colors";

import pxToRem from "../functions/pxToRem";

const { borderRadius } = borders;
const { white, slate_gray, navy, gold } = colors;

export default {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      backgroundColor: slate_gray.main,
      backgroundClip: "border-box",
      borderRadius: borderRadius.xl,
      overflow: "hidden",
    },

    // Hide scrollbar styles
    scrollbar: {
      "&::-webkit-scrollbar": {
        display: "none",
      },
      scrollbarWidth: "none",
      msOverflowStyle: "none",
    },

    // Color variants
    slate: {
      backgroundColor: slate_gray.main,
      color: white.main,
    },

    navy: {
      backgroundColor: navy.main,
      color: white.main,
    },

    gold: {
      backgroundColor: gold.main,
      color: white.main,
    },

    // Common paper variants
    contained: {
      backgroundColor: white.main,
      boxShadow: "0 0 2rem 0 rgba(0, 0, 0, 0.15)",
    },

    outlined: {
      border: `${pxToRem(1)} solid ${white.main}`,
    },

    elevation: {
      boxShadow: "0 0 2rem 0 rgba(0, 0, 0, 0.15)",
    },
  },
};
